<div
    [ngClass]="{
        'is-loading': isLoading,
        'drive': currentStateTacho === 0 && !isNoDriver,
        'work': currentStateTacho === 1 && !isNoDriver,
        'parking': currentStateTacho === 2 && !isNoDriver,
        'no-driver': isNoDriver
    }"
    class="tacho-list-full"
>
    <mat-spinner *ngIf="isLoading" [strokeWidth]="1" [diameter]="20"></mat-spinner>

    <ng-container *ngIf="!isLoading">
        <img class="drive-img" src="/assets/img/tacho/primary@2x.png" alt="">
        <img class="work-img" src="/assets/img/tacho/primary_3@2x.png" alt="">
        <img class="parking-img" src="/assets/img/tacho/primary_5@2x.png" alt="">
        <img class="no-driver-img" src="/assets/img/no-driver-icon.svg" alt="">
    </ng-container>

    <ng-container *ngIf="!isLoading && !isNoDriver">
        <ng-container *ngIf="currentStateTacho === 0">
            <span>{{ activeSlotData?.DD ? ((activeSlotData.DD / 1) | hoursTimeFormat) : '' }}</span>
        </ng-container>
        <ng-container *ngIf="currentStateTacho === 1">
            <span>{{ activeSlotData?.DW ? ((activeSlotData.DW / 1) | hoursTimeFormat) : '' }}</span>
        </ng-container>
        <ng-container *ngIf="currentStateTacho === 2">
            <span>{{ activeSlotData?.DR ? ((activeSlotData.DR / 1) | hoursTimeFormat) : '' }}</span>
        </ng-container>
        <ng-container *ngIf="currentStateTacho === 3">
            <span>{{ activeSlotData?.DRd ? ((activeSlotData.DRd / 1) | hoursTimeFormat) : '' }}</span>
        </ng-container>
    </ng-container>

    <span *ngIf="!isLoading && isNoDriver">
        <span>Brak</span>
    </span>
</div>